export default __webpack_public_path__ + "static/media/notification.a5ca9dc8.mp3";